import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class AdditionalExpenseOptionsModel extends BaseModel {
  static urlPath = "additional_expense";

  @attr("json") actions;
  @attr("string") description;
  @attr("string") name;
  @attr("json") parses;
  @attr("json") renders;

  get deductionTypeOptions() {
    return this.actions.POST.deduction_type.choices;
  }
}
